import { faGithub } from '@fortawesome/free-brands-svg-icons/faGithub';
import { faFacebookF } from '@fortawesome/free-brands-svg-icons/faFacebookF';
import { faInstagram } from '@fortawesome/free-brands-svg-icons/faInstagram';
import { faLinkedinIn } from '@fortawesome/free-brands-svg-icons/faLinkedinIn';
import { faEnvelope } from '@fortawesome/free-regular-svg-icons/faEnvelope';
// See https://fontawesome.com/icons?d=gallery&s=brands,regular&m=free
// to add other icons.

const data = [
  {
    link: 'https://github.com/patelrootul1',
    label: 'Github',
    icon: faGithub,
  },
  {
    link: 'https://www.facebook.com/patel.rootul/',
    label: 'Facebook',
    icon: faFacebookF,
  },
  {
    link: 'https://instagram.com/prootul99?igshid=NTc4MTIwNjQ2YQ==',
    label: 'Instagram',
    icon: faInstagram,
  },
  {
    link: 'https://www.linkedin.com/in/rootulpatel/',
    label: 'LinkedIn',
    icon: faLinkedinIn,
  },
  {
    link: 'mailto:rooatwork1@gmail.com',
    label: 'Email',
    icon: faEnvelope,
  },
];

export default data;
